function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8651"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8310",
    style: {
      fill: "#fff"
    },
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8646"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41413",
    d: "m356.08-1309.376 6.886-.019a1.189 1.189 0 0 1 .816-.2c1.242 0 2.484-.027 3.726.013a36.674 36.674 0 0 1 1.99 0 1.528 1.528 0 0 1 1.725 1.7c.009.284 0 .568-.006.851q.043 3.39 0 6.781a5.2 5.2 0 0 1-.087 1.519 1.583 1.583 0 0 1-1.633 1.04q-6.34.028-12.679 0a1.036 1.036 0 0 1-.737-.22z",
    transform: "translate(-355.08 1340.023)",
    style: {
      fill: "#0354a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41415",
    d: "M356.08-1233.258c4.442 0 8.883-.009 13.324.009a1.569 1.569 0 0 0 1.578-.858.616.616 0 0 1 .046.859c-.007.119-.019.237-.021.355-.018 1.743-.2 1.927-1.915 1.927H356.08z",
    transform: "translate(-355.08 1275.359)",
    style: {
      fill: "#05315c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41416",
    d: "M438.139-1476.546c.066-2.4-.541-2.346-2.391-2.3-.358.009-.717-.01-1.075-.017a1.045 1.045 0 0 1-.223-.8q-.014-3.054 0-6.108a1.306 1.306 0 0 1 .158-.753c.141-.152.275-.053.366.044a2.122 2.122 0 0 0 1.715.543q5.984-.011 11.967 0a6.428 6.428 0 0 0 .716-.021c.737-.083 1.106-.409 1.134-1.136a51.64 51.64 0 0 0 0-4.146 1.058 1.058 0 0 0-1.084-1.107 6.815 6.815 0 0 0-.859-.025c-3.893 0-7.787.005-11.681-.006a2.421 2.421 0 0 0-1.982.6.209.209 0 0 1-.264.02 1.246 1.246 0 0 1-.181-.82q-.007-6.642 0-13.284c0-.856.193-1.448 1.064-1.607h9.488a1.359 1.359 0 0 1 .213 1.021c.006 2.741 0 5.482 0 8.223a6.438 6.438 0 0 0 .024.857 1.065 1.065 0 0 0 1.473.983 26.907 26.907 0 0 0 1.973-.648 2.559 2.559 0 0 1 1.818 0q.908.331 1.836.608c1 .3 1.568-.1 1.626-1.158.026-.476.008-.953.009-1.43v-7.436a1.36 1.36 0 0 1 .213-1.021q6.848-.01 13.7-.015a1.168 1.168 0 0 1 1.221 1.15 4.1 4.1 0 0 1 .006.429v32.423c0 .214-.015.429-.023.643-2.28-.31-4.178.7-6.058 1.757a3.517 3.517 0 0 1-1.85.46c-1.315-.027-2.631-.013-3.946-.005a2.138 2.138 0 0 1-1.394-.468c-1.539-1.213-3.066-2.441-4.594-3.667-.2-.157-.445-.309-.367-.636.294-.284.668-.215 1.018-.217 1.693-.009 3.387 0 5.08-.006 1.327 0 1.59-.269 1.584-1.6a2.692 2.692 0 0 0-.071-.989 2.08 2.08 0 0 0-2.208-1.572c-3.061-.017-6.122 0-9.182-.008a2.317 2.317 0 0 0-1.458.507c-1.007.768-2.054 1.482-3.061 2.25a2.983 2.983 0 0 1-2.2.682c-.749-.078-1.53.2-2.25-.194z",
    transform: "translate(-422.192 1509.486)",
    style: {
      fill: "#e5b323"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41417",
    d: "M472.935-1311.3c1.7 1.345 3.4 2.684 5.092 4.041a1.747 1.747 0 0 0 1.18.409c1.218-.016 2.439-.058 3.652.011a4.418 4.418 0 0 0 2.629-.72 12.51 12.51 0 0 1 3.7-1.49 2.876 2.876 0 0 1 1.95.176l.167.161c0 .371-.328.441-.567.563-1.68.856-3.347 1.745-5.067 2.513-1.439.643-3.047.823-4.51 1.4a13.066 13.066 0 0 1-7.779.419c-2.961-.64-5.979-1.007-8.965-1.534a21.411 21.411 0 0 0-3.285-.156c-.328-.007-.677.057-.952-.2v-6.863c.693 0 1.39-.055 2.077.007a3.273 3.273 0 0 0 2.439-.778c.971-.769 1.989-1.478 2.985-2.215a2.023 2.023 0 0 1 1.246-.463c3.177.011 6.353 0 9.53.01a2.168 2.168 0 0 1 2.25 1.7c-.109.738-.694.776-1.241.789-1.575.036-3.151.012-4.727.013-1.632 0-1.636 0-1.731 1.581a2.252 2.252 0 0 0-.073.626z",
    transform: "translate(-444.23 1345.518)",
    style: {
      fill: "#ffe2cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41418",
    d: "M409.481-1507.5a1.457 1.457 0 0 0-.848 1.367q.019 7.189.018 14.379a.873.873 0 0 1 .2.657q.025 1.908 0 3.816a.873.873 0 0 1-.205.657l-.015 7.73h-4.595v-26.984c0-1.33.314-1.648 1.636-1.645 1.276 0 2.543.012 3.809.023z",
    transform: "translate(-396.156 1509.525)",
    style: {
      fill: "#ad871a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41419",
    d: "M517.2-1507.376v9.8c0 1.361-.738 1.965-1.957 1.414a6.012 6.012 0 0 0-5.27 0c-1.219.552-1.956-.053-1.957-1.414v-9.8z",
    transform: "translate(-485.195 1509.396)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41420",
    d: "M459.917-1262.07c3.337-.212 6.561.575 9.814 1.109 2.362.387 4.719.808 7.085 1.169a5.174 5.174 0 0 0 2.075-.458c2-.534 3.981-1.119 5.966-1.695a4.041 4.041 0 0 0 .715-.324c1.818-.943 3.7-1.766 5.47-2.8a1.342 1.342 0 0 1 .844 1.223c.013.6-.411.927-.906 1.173-1.88.934-3.718 1.966-5.65 2.777a43.893 43.893 0 0 1-4.563 1.4 8.564 8.564 0 0 0-1.236.339c-1.839.868-3.689.525-5.574.183a323.424 323.424 0 0 0-10.6-1.766 23.668 23.668 0 0 0-3.434-.023l-.046-.859q.023-.723.04-1.448z",
    transform: "translate(-443.971 1301.873)",
    style: {
      fill: "#ffc89e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6456"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41412",
    d: "M603.232-1170.6a2.307 2.307 0 0 1 2.442-1.872c2.965 0 5.931.041 8.9-.025a2.944 2.944 0 0 1 2.278.951c.576.572 1.181 1.12 1.716 1.729a2.238 2.238 0 0 0 1.884.8c2.295-.046 4.591-.016 6.887-.016v6.875a1.436 1.436 0 0 1-1.029.2c-2.318.005-4.638.06-6.954-.011a41.873 41.873 0 0 0-9.117.772c-2.817.534-5.655.95-8.483 1.428a3.587 3.587 0 0 1-1.626-.092c-2.227-.64-4.458-1.268-6.686-1.908a5.052 5.052 0 0 1-.872-.325c-1.646-.821-3.3-1.635-4.935-2.468-.261-.133-.6-.21-.629-.6.921-.731 1.905-.407 2.878-.159a5.172 5.172 0 0 1 .713.3c.286-.2.553-.043.811.062a6.729 6.729 0 0 1 1.341.666 4.911 4.911 0 0 0 3.181.8 51.8 51.8 0 0 1 4 0 4.944 4.944 0 0 0 3.385-.8 1.032 1.032 0 0 0 .324-.142c1.5-.771 2.808-1.824 4.223-2.721a2.753 2.753 0 0 0 .953-.715 3.269 3.269 0 0 1-.063-1c0-1.078-.011-1.09-1.062-1.094h-3.083a1.549 1.549 0 0 1-1.377-.635z",
    transform: "translate(-564.334 1218.288)",
    style: {
      fill: "#eab4ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41414",
    d: "M581.969-1121.4c2.978 1.6 5.929 3.255 9.278 4.008a19.7 19.7 0 0 1 3.153.9 6.561 6.561 0 0 0 3.773.04c3.017-.51 6.047-.951 9.051-1.525 3.888-.742 7.8-.277 11.706-.409 1.122-.038 2.246-.007 3.37-.007v2.292c-3.133 0-6.268.076-9.4-.023a39.435 39.435 0 0 0-7.731.78c-2.977.494-5.949 1.022-8.927 1.509a4.41 4.41 0 0 1-1.873-.4q-3.131-.872-6.258-1.76a2.758 2.758 0 0 1-.458-.2q-2.855-1.421-5.708-2.846a1.2 1.2 0 0 1-.82-1.151 1.27 1.27 0 0 1 .844-1.208z",
    transform: "translate(-559.3 1174.53)",
    style: {
      fill: "#d39e96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41421",
    d: "M624.938-1129.079a3.86 3.86 0 0 1-2.935 1.016c-1.836-.082-3.678-.05-5.517-.008a3.494 3.494 0 0 1-1.949-.566 9.347 9.347 0 0 0-2.519-1.167 2.128 2.128 0 0 1 2.338-1.546 6.415 6.415 0 0 1 2.378.685.557.557 0 0 1 .546-.014 1.931 1.931 0 0 1 .453.212 7.428 7.428 0 0 0 5.166 1.178 7.568 7.568 0 0 1 2.039.21z",
    transform: "translate(-585.757 1183.068)",
    style: {
      fill: "#d39e96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41422",
    d: "M699.967-1159.279c.942.623 2 .381 3.028.418.379.014.763-.027 1.139.01.506.049 1.287-.271 1.459.163a2.915 2.915 0 0 1-.045 2.129c-1.423 0-2.845 0-4.268-.011-.9-.007-1.309-.409-1.323-1.289-.007-.473.006-.947.01-1.42z",
    transform: "translate(-661.068 1206.968)",
    style: {
      fill: "#ffc89e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41423",
    d: "M653.064-1130.006c-1.431 0-2.862-.022-4.292 0a2.765 2.765 0 0 1-1.544-.441 11.2 11.2 0 0 0-2.368-1.148 2.352 2.352 0 0 1 2.578-.775 13.8 13.8 0 0 1 4.268 1.794 2.432 2.432 0 0 0 1.482.422z",
    transform: "translate(-613.883 1183.995)",
    style: {
      fill: "#b98881"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41424",
    d: "M436.148-1397.823v-5.13a1.5 1.5 0 0 1 1.56-.881c4.3.016 8.6.007 12.9.009 1.193 0 1.6.4 1.6 1.577 0 1.288.008 2.575 0 3.862-.008.993-.45 1.432-1.456 1.433-4.371.005-8.743 0-13.114.01a1.458 1.458 0 0 1-1.49-.88z",
    transform: "translate(-423.652 1420.719)",
    style: {
      fill: "#e5b323"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41425",
    d: "M547.96-1301.082a5.023 5.023 0 0 1-.121-2.156c-.005-.386.386-.267.621-.268 2.02-.009 4.04-.012 6.059 0a1.272 1.272 0 0 0 1.21-.592 4.047 4.047 0 0 1 .07 2.032c-.094.613-.6.853-1.23.85a521.723 521.723 0 0 0-5.868 0c-.249.001-.531-.105-.741.134z",
    transform: "translate(-519.256 1335.303)",
    style: {
      fill: "#ffc89e"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.30171e6079e888d8a02dfc8879b874e0.svg";
export { ForwardRef as ReactComponent };